import React from 'react';
import { useTracking } from 'react-tracking';

interface TrackingProps {
  tracking: {
    capture: (eventData: object) => void;
  };
}

const TrackingDecorator = <P extends object>(WrappedComponent: React.ComponentType<P & TrackingProps>) => {
  const TrackingComponent: React.FC<Omit<P, 'tracking'>> = (props) => {
    const tracking = useTracking();
    const handleCapture = (eventData: object) => {
      console.log(`${eventData}`);
    };
    const trackedProps = {
      ...props,
      tracking: {
        ...tracking,
        capture: handleCapture,
      },
    } as unknown as P & TrackingProps;
    return <WrappedComponent {...trackedProps} />;
  };
  return TrackingComponent;
};

export default TrackingDecorator;
